{
    "cart": {
        "title": "{count} Artikel im Warenkorb",
        "titleEmpty": "Warenkorb",
        "close": "Warenkorb schließen",
        "loading": "Wird geladen …",
        "orderSummary": "Bestellübersicht",
        "total": "Gesamt",
        "subtotal": "Zwischensumme",
        "tax": "Inkl. MwSt.",
        "shipping": "Versand",
        "discount": "Rabatt",
        "empty": "Noch nichts eingepackt.",
        "emptyShopCta": "Im Shop stöbern",
        "checkout": "Zur Kasse",
        "buttonLabel": "Warenkorb, {count} Artikel",
        "removeItem": "Entfernen",
        "increment": "Anzahl erhöhen",
        "decrement": "Anzahl verringern",
        "quantity": "Anzahl",
        "couponCode": "Gutscheincode",
        "applyCoupon": "Einlösen",
        "removeCoupon": "Gutschein entfernen",
        "errors": {
            "loadFailed": "Warenkorb konnte nicht geladen werden",
            "addFailed": "Artikel konnte nicht hinzugefügt werden",
            "updateFailed": "Warenkorb konnte nicht aktualisiert werden",
            "removeFailed": "Artikel konnte nicht entfernt werden",
            "couponFailed": "Gutscheincode konnte nicht eingelöst werden"
        }
    },
    "addToCart": {
        "default": "In den Warenkorb",
        "inCart": "Im Warenkorb ({qty})",
        "selectLabel": "Variante wählen",
        "outOfStock": "Ausverkauft"
    },
    "checkout": {
        "shoppingCart": "Warenkorb",
        "details": {
            "fields": {
                "fullName": "Name",
                "organization": "Organisation / Unternehmen",
                "addressLine1": "Adresszeile 1",
                "addressLine2": "Adresszeile 2",
                "countryCode": "Land",
                "countryCodePlaceholder": "Land wählen",
                "postalCode": "Postleitzahl",
                "locality": "Ort"
            }
        }
    }
}
